import React from "react";
import type { AdMode } from "../lib/site-config.js";

export function Mascot({ type }: { type: "spark" | "bolt" | "bloop" }) {
  return (
    <div className={`mascot mascot-${type}`} aria-hidden="true">
      <div className="eye left" />
      <div className="eye right" />
      <div className="smile" />
    </div>
  );
}

function FooterAd({ label, secondary }: { label: string; secondary?: boolean }) {
  return (
    <div
      className={`footer-ad-inline${secondary ? " footer-ad-secondary" : ""}`}
      aria-label="Advertisement area"
    >
      <span>Ad Space</span>
      <strong>{label}</strong>
    </div>
  );
}

export function TopRightHeroAd() {
  return (
    <div className="footer-ad-inline top-mini-ad" aria-label="Advertisement area">
      <span>Ad Space</span>
      <strong>Top Right</strong>
    </div>
  );
}

export function SiteNav() {
  return (
    <nav className="site-nav">
      <MisterGamesLogo />
      <div className="site-nav-right">
        <ul className="site-nav-links">
          <li><a href="/#games">Games</a></li>
          <li><a href="/#crew">Crew</a></li>
          <li><a href="/#about">About</a></li>
        </ul>
        <a className="site-nav-cta" href="/#games">Play Now</a>
      </div>
    </nav>
  );
}

export function MisterGamesLogo() {
  return (
    <a className="site-logo-link" href="/" aria-label="MisterGames home">
      <img className="site-logo" src="/mistergames-logo.png?v=20260523a" alt="MisterGames" />
    </a>
  );
}

interface SiteStickyFooterProps {
  adMode?: AdMode;
}

export function SiteStickyFooter({ adMode = 'bottom-4' }: SiteStickyFooterProps) {
  const isResponsive = adMode === 'responsive';
  const showAds = adMode !== 'off';

  // In responsive mode we render all slots and let CSS hide secondary ones at breakpoints.
  const showExtraSlots =
    adMode === 'bottom-4' || isResponsive;

  // In responsive mode the entire ad row gets a class that CSS can target.
  const footerClass = `sticky-footer${isResponsive ? " footer-responsive" : ""}`;

  return (
    <footer className={footerClass}>
      {showAds && (
        <div className="footer-ads-row">
          <div className="footer-ads-col">
            <FooterAd label="Left Banner 1" />
            {showExtraSlots && <FooterAd label="Left Banner 2" secondary={isResponsive} />}
            {showExtraSlots && <FooterAd label="Left Banner 3" secondary={isResponsive} />}
            {showExtraSlots && <FooterAd label="Left Banner 4" secondary={isResponsive} />}
          </div>
          <div className="footer-ads-col footer-ads-col-right">
            {showExtraSlots && <FooterAd label="Right Banner 4" secondary={isResponsive} />}
            {showExtraSlots && <FooterAd label="Right Banner 3" secondary={isResponsive} />}
            {showExtraSlots && <FooterAd label="Right Banner 2" secondary={isResponsive} />}
            <FooterAd label="Right Banner 1" />
          </div>
        </div>
      )}
      <p className="footer-copyright">© {new Date().getFullYear()} MisterGames. Play fair. Have fun.</p>
    </footer>
  );
}
